import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import Header from './components/Header';
import Footer from './components/Footer';
import HeroSection from './components/HeroSection';
import CarouselSection from './components/CarouselSection';
import MediaSection from './components/MediaSection';
import AppSection from './components/AppSection';
import TopicsSection from './components/TopicsSection';
import ContactSection from './components/ContactSection';
import AboutSection from './components/AboutSection';
import UpdatesSection from './components/UpdatesSection';
import CardsSection from './components/CardsSection';
import RankingSection from './components/RankingSection';
import FeaturesSection from './components/FeaturesSection';
import IndexSection from './components/IndexSection';
import CommentsSection from './components/CommentsSection';
import FaqSection from './components/FaqSection';

export default function Home() {
  const location = useLocation();

  useEffect(() => {
    if (location.hash) {
      const el = document.querySelector(location.hash);
      if (el) {
        setTimeout(() => {
          el.scrollIntoView({ behavior: 'smooth' });
        }, 100);
      }
    }
  }, [location.hash]);

  return (
    <>
      <Header />

      <main>
        <HeroSection />
        <CarouselSection />
        <MediaSection />
        <AppSection />
        <TopicsSection />
        <ContactSection />
        <AboutSection />
        <UpdatesSection />
        <CardsSection />
        <RankingSection />
        <FeaturesSection />
        <IndexSection />
        <CommentsSection />
        <FaqSection />
      </main>

      <Footer />
    </>
  );
}